/* Jane Lushka — quick-add size strip on LimeSpot recommendation cards.
   Hover a card -> size strip appears over the image bottom; clicking a size
   adds that variant to cart and opens the theme cart drawer (Meshki pattern).
   Desktop / hover devices only. */
(function () {
  if (!window.matchMedia('(hover: hover) and (min-width: 768px)').matches) return;

  var SIZE_NAME = /^(size|maat|gr(ö|oe?)(ß|ss)e)$/i;
  var ENHANCED = 'jlQuickaddDone';

  function enhance(card) {
    if (card.dataset[ENHANCED]) return;
    var link = card.querySelector('a[href*="/products/"]');
    var wrap = card.querySelector('.ls-image-wrap') || card.querySelector('.product-card__media');
    if (!link || !wrap) return;
    card.dataset[ENHANCED] = '1';

    var strip = document.createElement('div');
    strip.className = 'jl-size-strip';
    strip.innerHTML = '<span class="jl-size-strip__loading">…</span>';
    wrap.appendChild(strip);

    var loaded = false;
    function loadOnce() {
      if (loaded) return;
      loaded = true;
      var url = link.getAttribute('href').split('?')[0] + '.js';
      fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (product) { renderSizes(strip, product); })
        .catch(function () { strip.remove(); });
    }
    card.addEventListener('mouseenter', loadOnce);
    /* keyboard users reveal the strip via :focus-within — load sizes then too */
    card.addEventListener('focusin', loadOnce);
  }

  function renderSizes(strip, product) {
    var sizeIdx = -1;
    (product.options || []).forEach(function (opt, i) {
      var name = typeof opt === 'string' ? opt : opt.name;
      if (SIZE_NAME.test(name)) sizeIdx = i;
    });
    if (sizeIdx === -1 && product.options && product.options.length === 1) sizeIdx = 0;
    if (sizeIdx === -1) { strip.remove(); return; }

    strip.innerHTML = '';
    var seen = {};
    (product.variants || []).forEach(function (v) {
      var label = v['option' + (sizeIdx + 1)];
      if (!label || seen[label]) return;
      seen[label] = true;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'jl-size-strip__btn';
      btn.textContent = label;
      if (!v.available) {
        btn.disabled = true;
        btn.classList.add('is-soldout');
      } else {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          addToCart(v.id, btn);
        });
      }
      strip.appendChild(btn);
    });
    if (!strip.children.length) strip.remove();
  }

  function addToCart(variantId, btn) {
    var drawer = document.querySelector('cart-drawer');
    var notification = document.querySelector('cart-notification');
    var sections = [];
    if (drawer && drawer.getSectionsToRender) {
      sections = sections.concat(drawer.getSectionsToRender().map(function (s) { return s.id; }));
    }
    if (notification && notification.getSectionsToRender) {
      sections = sections.concat(notification.getSectionsToRender().map(function (s) { return s.id; }));
    }

    btn.classList.add('is-loading');
    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', '1');
    if (sections.length) {
      body.append('sections', sections.join(','));
      body.append('sections_url', window.location.pathname);
    }

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
      body: body
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status === 422) throw new Error(state.description || 'unavailable');
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        var original = btn.textContent;
        btn.textContent = '\u2713';
        setTimeout(function () {
          btn.classList.remove('is-added');
          btn.textContent = original;
        }, 1400);
        if (drawer && state.sections) {
          drawer.renderContents(state);
          if (drawer.open) drawer.open();
        }
      })
      .catch(function () {
        /* sold-out race or network error: show a brief inline error instead of
           yanking the shopper to a cart page that doesn't contain the item */
        btn.classList.remove('is-loading');
        var original = btn.textContent;
        btn.classList.add('is-soldout');
        btn.textContent = '✕';
        setTimeout(function () {
          btn.classList.remove('is-soldout');
          btn.textContent = original;
        }, 1400);
      });
  }

  function scan(root) {
    if (!root.querySelectorAll) return;
    root.querySelectorAll('.limespot-recommendation-box-item, .product-card').forEach(enhance);
  }

  var observer = new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.classList && (n.classList.contains('limespot-recommendation-box-item') || n.classList.contains('product-card'))) enhance(n);
        else scan(n);
      });
    });
  });

  function init() {
    scan(document);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
